$(document).ready(function(){
    var swiper = new Swiper('.product-media', {
        loop: true,
        effect: 'fade',
        allowTouchMove: true,
        paginationClickable: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        }
    });
});

function handleScroll() {
    const body = document.body;
    const scrollPosition = window.scrollY;
    const scrollThreshold = 100;

    if (scrollPosition >= scrollThreshold) {
        body.classList.add('scrolled');
    } else {
        body.classList.remove('scrolled');
    }
}
window.addEventListener('scroll', handleScroll);

document.addEventListener('DOMContentLoaded', function() {
    const openBtn = document.querySelector('.custom_swatchBtn_wrapper'); 
    const fabricWrapper = document.querySelector('.varaints_popupWp');
    const body = document.body;

    if (!openBtn || !fabricWrapper) return;

    openBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        fabricWrapper.classList.toggle('fabric-sidebar-open');
        
        if (fabricWrapper.classList.contains('fabric-sidebar-open')) {
            body.classList.add('variants_popup_open');
        } else {
            body.classList.remove('variants_popup_open');
        }
    });

    const closeButtons = fabricWrapper.querySelectorAll('.close-fabric, .close-fabric-mobile, [class*="close"]');
    
    closeButtons.forEach(btn => {
        btn.addEventListener('click', function(e) {
            e.preventDefault();     
            e.stopPropagation();    
            fabricWrapper.classList.remove('fabric-sidebar-open');
            body.classList.remove('variants_popup_open');
        });
    });

    document.addEventListener('click', function(e) {
        if (!fabricWrapper.contains(e.target) && !openBtn.contains(e.target)) {
            fabricWrapper.classList.remove('fabric-sidebar-open');
            body.classList.remove('variants_popup_open');
        }
    });

    const swatches = document.querySelectorAll(".fabric-swatch-item");
    const detailOuter = document.querySelector(".fabric-detail-outer");
    const detailImage = document.querySelector(".fabric-detail-image");
    const detailContent = document.querySelector(".fabric-detail-content");
    const closeMobileBtn = document.querySelector(".close-fabric-mobile");
    const mobileTitle = document.querySelector(".mobile-fabric-title");
    const mobileImage = document.querySelector(".mobile-fabric-image");

    swatches.forEach(item => {
        item.addEventListener("mouseenter", function () {
            const imageURL = this.dataset.fabricImage;
            const detailsHTML = this.dataset.fabricDetails;
            const variantTitle = this.querySelector(".fabric-name") ? this.querySelector(".fabric-name").textContent : "";
            const featuredImage = this.dataset.featuredImage;

            if (detailOuter) detailOuter.classList.add("active");
            if (detailImage && imageURL) detailImage.innerHTML = `<img src="${imageURL}" alt="Fabric Image">`;
            if (detailContent && detailsHTML) detailContent.innerHTML = detailsHTML;
            
            if (mobileTitle) mobileTitle.textContent = variantTitle;
            if (mobileImage && featuredImage) {
                mobileImage.src = featuredImage;
                mobileImage.alt = variantTitle;
            }
        });

        item.addEventListener("mouseleave", function () {
            if (detailOuter) {
                const isHoveringDetailBox = detailOuter.matches(":hover");
                if (!isHoveringDetailBox) {
                    detailOuter.classList.remove("active");
                }
            }
        });

        item.addEventListener("click", function (e) {
            e.stopPropagation(); 
            
            const variantTitleEl = this.querySelector(".fabric-name");
            if (!variantTitleEl) return;
            
            const variantTitle = variantTitleEl.textContent;
            const formField = document.getElementById("ContactFormCollection");

            if (formField) {
                const productTitle = formField.getAttribute("data-title") || "";
                const combinedTitle = `${productTitle} in ${variantTitle}`;
                formField.value = combinedTitle;
            }

            const swatchTextEl = document.querySelector(".cus_swatch_text");
            if (swatchTextEl) {
                swatchTextEl.textContent = variantTitle;
            }
        });
    });

    if (detailOuter) {
        detailOuter.addEventListener("mouseleave", function () {
            detailOuter.classList.remove("active");
        });
    }

    if (closeMobileBtn) {
        closeMobileBtn.addEventListener("click", function() {
            if (detailOuter) detailOuter.classList.remove("active");
        });
    }

    function initFabricClick() {
        const swiperContainer = document.querySelector(".product-media.swiper-container");
        if (!swiperContainer || !swiperContainer.swiper) {
            setTimeout(initFabricClick, 100);
            return;
        }
        const swiperInstance = swiperContainer.swiper;

        swatches.forEach(item => {
            item.addEventListener("click", function() {
                swatches.forEach(i => i.classList.remove("active"));
                this.classList.add("active");

                const rawVariantName = this.getAttribute("get-variant-name");
                if (!rawVariantName) return;

                const variantName = rawVariantName.toLowerCase();
                const slidesArray = Array.from(swiperInstance.slides);
                let targetIndex = null;

                slidesArray.forEach((slide, index) => {
                    const img = slide.querySelector("img");
                    if (img && img.getAttribute("data-media-alt") && img.getAttribute("data-media-alt").toLowerCase() === variantName) {
                        targetIndex = index;
                    }
                });

                if (targetIndex !== null) {
                    swiperInstance.slideTo(targetIndex);
                }
            });
        });
    }

    initFabricClick();
});


